import { ref, toRef, watch } from 'vue';
import { useAnimatedCount } from '../../composables/useAnimatedCount.js';
import { useSparkline } from '../../composables/useSparkline.js';

export default (props, { emit }) => {
  const localSelected = ref(props.selected);

  const { computedSparklineColor, computedGradient, chipColor, labelStyle } = useSparkline(props);

  // First change snaps, later changes animate (variant A); a null/undefined count shows 0
  const { displayCount } = useAnimatedCount(toRef(props, 'count'), { nullAsZero: true });

  watch(() => props.selected, (newValue) => {
    localSelected.value = newValue;
  });

  // Bound to the switch's native `change`, which fires after v-model has written localSelected
  const handleSwitchChange = () => {
    emit('update:selected', localSelected.value);
    emit('filterChange', {
      id: props.identifier,
      selected: localSelected.value
    });
  };

  return {
    localSelected,
    computedSparklineColor,
    computedGradient,
    chipColor,
    labelStyle,
    displayCount,
    handleSwitchChange,
  };
};
